import { legacy_connect as connect } from 'react-redux';

import { AppState } from '../../../store/reducers/root';
import { getActiveFormsIds } from '../../../store/selectors/form';

import ActiveForms from './ActiveForms';

const mapStateToProps = (state: AppState) => ({
  ids: getActiveFormsIds(state),
});

export default connect(mapStateToProps)(ActiveForms);
